import API_URL from "../config/axios_defaults";
import axios from 'axios';

export default class ImportantDatesService {
  async getDates(termCode) {

    const res = await axios.get(`${API_URL}/api/important_dates/${termCode}`, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'applicaiton/json'
      }

    });

    const dates = res.data.data.important_dates;

    return dates;
  }

  async saveImportantDate(termCode, importantDate) {
    try {
      const res = await axios.put(`${API_URL}/api/important_dates/${termCode}`, 
      JSON.stringify(importantDate),
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'applicaiton/json'
        },
      });
  
      return res.data;
    } catch (e) {
      return e;
    }
  }

  async removeSession(id) {
    try {
      const res = await axios.delete(`${API_URL}/api/important_dates/remove_session/${id}`, 
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'applicaiton/json'
        },
      });
  
      return res.data;
    } catch (e) {
      return e;
    }    
  }

  async deleteDate(id) {
    try {
      const res = await axios.delete(`${API_URL}/api/important_dates/${id}`, 
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'applicaiton/json'
        },
      });
  
      return res.data;
    } catch (e) {
      return e;
    }    
  }

}
